// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edit-dose-modal {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
}

.edit-timestamp {
    width: auto;
    box-sizing: border-box;
    margin: 0.25rem 0 1.25rem;
    padding: 0;
    font-family: inherit;
    font-size: 2.6rem;
    font-weight: bold;
    letter-spacing: 0.05em;
    text-align: center;
    color: var(--header-color);
    background-color: transparent;
    border: none;
}

.edit-timestamp::-webkit-calendar-picker-indicator {
    display: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/EditDoseModal.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,yBAAyB;IACzB,UAAU;IACV,oBAAoB;IACpB,iBAAiB;IACjB,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,0BAA0B;IAC1B,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB","sourcesContent":[".edit-dose-modal {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n}\n\n.edit-timestamp {\n    width: auto;\n    box-sizing: border-box;\n    margin: 0.25rem 0 1.25rem;\n    padding: 0;\n    font-family: inherit;\n    font-size: 2.6rem;\n    font-weight: bold;\n    letter-spacing: 0.05em;\n    text-align: center;\n    color: var(--header-color);\n    background-color: transparent;\n    border: none;\n}\n\n.edit-timestamp::-webkit-calendar-picker-indicator {\n    display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
